const POINTER_HOVER = '(hover: hover) and (pointer: fine)';
const TOUCH_POINTER = '(any-pointer: coarse)';

function hoverQuery({ minWidth = 761 } = {}) {
  return minWidth > 0 ? `(min-width: ${minWidth}px) and ${POINTER_HOVER}` : POINTER_HOVER;
}

export function supportsDesktopHover(options) {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia(hoverQuery(options)).matches
    && !window.matchMedia(TOUCH_POINTER).matches;
}

export function watchDesktopHover(update, options) {
  const queries = [window.matchMedia(hoverQuery(options)), window.matchMedia(TOUCH_POINTER)];
  const sync = () => update(supportsDesktopHover(options));
  queries.forEach(query => query.addEventListener('change', sync));
  sync();
  return () => queries.forEach(query => query.removeEventListener('change', sync));
}
